(function () {
    'use strict';

    angular.module('ecap.siteConfiguration', []);
})();
